module.exports = "/lucky-balls/img/bigball/BigBall_016.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_016.png
// module id = 911
// module chunks = 0